  import React, { useEffect, useState } from 'react';
  import { useAPI } from '../../../../shared/services/api/API';
  import { WASHUB_CONSTANTS } from '../../../../shared/Constants';
  import dayjs from 'dayjs';
  import {
    Button,
    Card,
    CardActions,
    Grid,
    MenuItem,
    TextField,
  } from '@mui/material';
  import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
  export const DailyRevenue = () => {
    const { axiosInstance , handleAlertBar} = useAPI();
    const [isLoading, setIsLoading] = useState(false);
    const type = localStorage.getItem('userType');
  
    // POST with API : Generate Daily Revenue Summury Report
    const generateDailyRevenueReport = async () => {
      const payload = {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
      };
      axiosInstance
        .post(
          WASHUB_CONSTANTS.API_URLS
            .REPORT_GENERATE_DAILY_REVENUE_FOR_BUSINESS_STORE,
          payload,
          {
            headers: {
              Authorization: localStorage.getItem('jwtToken') || null,
            },
            responseType: 'blob',
          },
        )
        .then((response: any) => {
          if (response.status === 200) {
            const blob = new Blob([response.data], {type: 'application/xlsx'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const fileName = `Daily-Revenue-${payload.startDate} to ${payload.endDate}.xlsx`;
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
  
            a.remove();
            window.URL.revokeObjectURL(url);
          } else {
            if (response.data.error) {
              console.error(
                'Error fetching BusinessStoreInvoices: ',
                response.data.message,
              );
            }
          }
        }).catch((error: any) => {
          handleAlertBar('error', 'Business Order Item not found');
        });
    };
  
    const [startDate, setStartDate] = useState(dayjs().subtract(5, 'days'));
    const [endDate, setEndDate] = useState(dayjs());
    const handleStartDateChange = (date: any) => {
      setStartDate(date);
    };
    const handleEndDateChange = (date: any) => {
      setEndDate(date);
    };

    return (
      <div>
        <Card sx={{ margin: '5px 15px' }} elevation={2}>
          <CardActions>
            <Grid container className="m-2" spacing={2}>
              <Grid item xs={12} sm={12} md lg>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={'Start date'}
                    slotProps={{ textField: { variant: 'standard' } }}
                    name="startDate"
                    value={dayjs(startDate)}
                    onChange={handleStartDateChange}
                    sx={{ width: '50%' }}
                  />
                </LocalizationProvider>
              </Grid>
  
              <Grid item xs={12} sm={12} md lg>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label={'End date'}
                    slotProps={{ textField: { variant: 'standard' } }}
                    name="endDate"
                    value={dayjs(endDate)}
                    minDate={dayjs(startDate)}
                    onChange={handleEndDateChange}
                    sx={{ width: '50%' }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item>
                  <Button
                    variant="contained"
                    onClick={generateDailyRevenueReport}
                  >
                    Download the Report
                  </Button>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </div>
    );
  };
  